import { Skeleton } from 'antd';
import classNames from 'classnames';

export default function ProposalCardSkeleton({
  withActions = false,
  withPadding = false,
}: {
  withPadding?: boolean;
  withActions?: boolean;
}) {
  return (
    <div
      className={classNames(
        'rounded-lg bg-surface-primary',
        withPadding && 'p-4 border'
      )}
      data-testid="proposal-card-skeleton"
    >
      {/* Header */}
      <div className="flex items-center gap-3 mb-4" data-testid="proposal-card-skeleton-header">
        <Skeleton.Avatar active size={85} />

        <div className="flex-1" data-testid="proposal-card-skeleton-header-info">
          <Skeleton.Input active size="small" style={{ width: 200 }} />
          <div className="mt-2 flex gap-3" data-testid="proposal-card-skeleton-header-stats">
            <Skeleton.Input active size="small" style={{ width: 120 }} />
          </div>
        </div>
      </div>

      {/* Cover letter */}
      <div className="mb-4 space-y-3" data-testid="proposal-card-skeleton-cover-letter">
        <Skeleton.Input active size="small" style={{ width: 120 }} />

        <div className="mt-2" data-testid="proposal-card-skeleton-cover-letter-body">
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </div>
      </div>

      {/* Price + Delivery */}
      {withActions && (
        <div className="flex gap-8 mb-4" data-testid="proposal-card-skeleton-pricing">
          <div data-testid="proposal-card-skeleton-price">
            <Skeleton.Input active size="small" style={{ width: 100 }} />
            <div className="mt-2" data-testid="proposal-card-skeleton-price-value">
              <Skeleton.Input active size="large" style={{ width: 120 }} />
            </div>
          </div>

          <div data-testid="proposal-card-skeleton-delivery">
            <Skeleton.Input active size="small" style={{ width: 100 }} />
            <div className="mt-2" data-testid="proposal-card-skeleton-delivery-value">
              <Skeleton.Input active size="large" style={{ width: 100 }} />
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      {withActions && (
        <div className="flex justify-between items-center" data-testid="proposal-card-skeleton-footer">
          <Skeleton.Input active size="small" style={{ width: 120 }} />

          <div className="flex items-center gap-3" data-testid="proposal-card-skeleton-footer-actions">
            <Skeleton.Input
              active
              size="small"
              className="!w-[140px] !h-[40px] rounded"
            />

            <Skeleton.Input
              active
              size="small"
              className="!w-[140px] !h-[40px] rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
}
